import { useEffect, useMemo } from "react";
import LorsForm from "@/components/landing/lors/LorsForm";
import { getOnDemandCopy } from "@/components/landing/lors/translationsOnDemand";
import { captureUtmsFromUrl } from "@/components/landing/lors/utmStorage";

// Bare registration form for embedding in an iframe on lawofficeofruby.com.
const OnDemandWebinarEmbed = () => {
  useEffect(() => {
    captureUtmsFromUrl();
    const prev = document.documentElement.lang;
    document.documentElement.lang = "en";
    document.body.style.background = "transparent";
    return () => {
      document.documentElement.lang = prev;
      document.body.style.background = "";
    };
  }, []);

  const copy = useMemo(() => getOnDemandCopy(), []);

  return (
    <main className="lors-theme p-2">
      <LorsForm
        copy={copy}
        redirectTo="/on-demand-webinar/ty"
        formKey="odw"
        hideMeta
      />
    </main>
  );
};

export default OnDemandWebinarEmbed;
